<template>
  <component
    v-bind:is="tag"
    v-bind:class="['text-block', {'full-screen': fullScreen}]"
  >
    <h1>{{ category.title }}</h1>
    <p>{{ category.description }}</p>
    <router-link
      v-if="link"
      v-bind:to="link.route"
    >
      {{ link.text }}
    </router-link>
  </component>
</template>

<script>
export default {
  name: 'CatalogCategoryTextBlock',
  props: {
    category: {
      type: Object
    },
    link: {
      type: Object,
      default: null
    },
    fullScreen: {
      type: Boolean
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  data: function () {
    return {}
  }
}
</script>

<style scoped lang="scss">
  .text-block {
    padding: 0.5em 0;
    @include text-block($desktop: 70%);
    & > a {
      @include framed-color-reversible-button();
    }
    &.full-screen {
      padding: 2em 0;
      @include text-block();
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/the-content/catalog-category-banner/CatalogCategoryTextBlock.vue